import { Toaster } from "sonner";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AppProviders } from "@/lib/providers";
import { PublicLayout, RequireAuth } from "@/components/site/Layout";
import Home from "@/pages/Home";
import Courses from "@/pages/Courses";
import CourseDetail from "@/pages/CourseDetail";
import Checkout from "@/pages/Checkout";
import { Login, Register, ForgotPassword, ResetPassword } from "@/pages/Auth";
import Dashboard from "@/pages/Dashboard";
import Learn from "@/pages/Learn";
import { About, Contact, FaqPage, Privacy, Terms, NotFound } from "@/pages/StaticPages";
import AdminLayout from "@/pages/admin/AdminLayout";
import { AdminGate } from "@/pages/admin/AdminLogin";
import AdminOverview from "@/pages/admin/AdminOverview";
import AdminCourses from "@/pages/admin/AdminCourses";
import AdminCourseEditor from "@/pages/admin/AdminCourseEditor";
import AdminPayments from "@/pages/admin/AdminPayments";
import AdminStudents from "@/pages/admin/AdminStudents";
import AdminEnrollments from "@/pages/admin/AdminEnrollments";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminReels from "@/pages/admin/AdminReels";

function App() {
  return (
    <div className="App">
      <AppProviders>
        <BrowserRouter>
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/courses" element={<Courses />} />
              <Route path="/courses/:slug" element={<CourseDetail />} />
              <Route path="/checkout/:slug" element={<RequireAuth><Checkout /></RequireAuth>} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/dashboard" element={<RequireAuth><Dashboard /></RequireAuth>} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/faq" element={<FaqPage />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="*" element={<NotFound />} />
            </Route>
            <Route path="/learn/:courseId" element={<RequireAuth><Learn /></RequireAuth>} />
            <Route path="/learn/:courseId/:lessonId" element={<RequireAuth><Learn /></RequireAuth>} />
            <Route path="/admin" element={<AdminGate><AdminLayout /></AdminGate>}>
              <Route index element={<AdminOverview />} />
              <Route path="courses" element={<AdminCourses />} />
              <Route path="courses/:id" element={<AdminCourseEditor />} />
              <Route path="payments" element={<AdminPayments />} />
              <Route path="students" element={<AdminStudents />} />
              <Route path="enrollments" element={<AdminEnrollments />} />
              <Route path="reels" element={<AdminReels />} />
              <Route path="settings" element={<AdminSettings />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors dir="rtl" toastOptions={{ style: { fontFamily: "Readex Pro, sans-serif", fontSize: "14px", fontWeight: 500 } }} />
      </AppProviders>
    </div>
  );
}

export default App;
